export const isBlogPath = (pathname) => {
  const path = String(pathname || '');
  return path === '/blog' || path.startsWith('/blog/');
};

export const readBlogSearchQuery = (search) => {
  const params = new URLSearchParams(search || '');
  return String(params.get('search') || '').trim();
};

export const buildBlogSearchLocation = (keyword) => {
  const normalized = String(keyword || '').trim();
  if (!normalized) {
    return { pathname: '/blog', search: '' };
  }
  return {
    pathname: '/blog',
    search: `?search=${encodeURIComponent(normalized)}`,
  };
};

const matchesSearchQuery = (post, query) => {
  const title = post.title?.toLowerCase() || '';
  const excerpt = post.excerpt?.toLowerCase() || '';
  const category = post.category?.toLowerCase() || '';
  const tags = (post.tags || []).map((tag) => tag.toLowerCase()).join(' ');
  return title.includes(query)
    || excerpt.includes(query)
    || category.includes(query)
    || tags.includes(query);
};

const matchesTopic = (post, topicLower) => (
  (post.category?.toLowerCase() || '') === topicLower
);

export const filterBlogPosts = (posts, { search, topic } = {}) => {
  let filtered = [...(posts || [])];
  if (search) {
    const query = search.toLowerCase();
    filtered = filtered.filter((post) => matchesSearchQuery(post, query));
  }
  if (topic) {
    const topicLower = topic.toLowerCase();
    filtered = filtered.filter((post) => matchesTopic(post, topicLower));
  }
  return filtered;
};
